<template>
    <div class="home">
        <b-img src="images/bild.jpg" fluid />
        <span v-html="$t('presentation.tender')" />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'ausschreibungen',
        data() {
            return {};
        },
        computed: {
            ...mapGetters({
                auth: 'auth/auth'
            })
        }
    }
</script>